import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
// import Header from './components/Header';
import { StickyNavbar } from './components/navbar';
import { ThemeProvider } from "@material-tailwind/react";
import StartAProject from './pages/StartAProject';
import ProductScope  from "./pages/ProductScope";
import UiUX from './pages/UiUx';
import Footer from './components/Footer';
import MVBbuilder from './pages/MVBbuilder';
import DedicatedTeams from './pages/DedicatedTeams';
import CustomSoftwareDevelopment from './pages/CustomSoftwareDevelopment';
import ServiceAi from './pages/ServiceAi'; 
import Work from './pages/Work';
import AboutUs from './pages/AboutUs';
import Tech from './pages/Tech';
const App = () => {
  return (
    <ThemeProvider>
      <Router>
        <StickyNavbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/start-a-project" element={<StartAProject />} />
          <Route path="/product-scope" element={<ProductScope />} />
          <Route path="/ui-ux" element={<UiUX />} />
          <Route path="/mvp-builder" element={<MVBbuilder />} />
          <Route path="/dedicated-teams" element={<DedicatedTeams />} />
          <Route path="/custom-software-development" element={<CustomSoftwareDevelopment />} />
          <Route path="/service-ai" element={<ServiceAi />} />
          <Route path="/work" element={<Work />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/tech" element={<Tech />} />
        </Routes>
        <Footer />
      </Router>
    </ThemeProvider>
  );
};

export default App;
